import { UserApr } from '../../../types/lenderTypes'
import { safeDivide } from './formatting'

export * from './createGeneralUserState'
export * from './getBalanceForMarketUid'
export * from './createSumerUserState'
export * from './formatting'
export * from './createMultiAccountStyleUserState'
export * from './types'
export * from './oraclePrice'

export function divideAccrualsToAprs(
  aprs: { [assets: string]: UserApr },
  nav: number,
  deposits: number,
  debt: number,
) {
  if (nav === 0) return {}
  let d: any = {}
  Object.entries(aprs).map(([k, data]) => {
    d[k] = {
      apr: safeDivide(data.borrowApr + data.depositApr, nav),
      borrowApr: safeDivide(data.borrowApr, debt),
      depositApr: safeDivide(data.depositApr, deposits),
    }
  })
  return d
}
